import React, { useState } from 'react';
import PropTypes from 'prop-types';

const StepServicesHours = ({ data, onChange }) => {
  const [serviceInput, setServiceInput] = useState('');
  
  const daysOfWeek = [
    'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
  ];

  const handleAddService = () => {
    if (serviceInput.trim()) {
      const updatedServices = [...(data.services || []), serviceInput.trim()];
      onChange({ ...data, services: updatedServices });
      setServiceInput('');
    }
  };

  const handleRemoveService = (index) => {
    const updatedServices = (data.services || []).filter((_, i) => i !== index);
    onChange({ ...data, services: updatedServices });
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddService();
    }
  };

  const toggleDay = (day) => {
    const currentDays = data.operatingDays || [];
    const updatedDays = currentDays.includes(day)
      ? currentDays.filter(d => d !== day)
      : [...currentDays, day];
    onChange({ ...data, operatingDays: updatedDays });
  };

  return (
    <div className="step-card">
      <div className="form-group">
        <label>Services Offered</label>
        <div className="service-input-container">
          <input
            type="text"
            value={serviceInput}
            onChange={(e) => setServiceInput(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter a service"
            className="service-input"
          />
          <button
            type="button"
            onClick={handleAddService}
            className="add-service-btn"
          >
            Add
          </button>
        </div>
        <div className="services-chips">
          {(data.services || []).map((service, index) => (
            <div key={index} className="service-chip">
              <span>{service}</span>
              <button
                type="button"
                onClick={() => handleRemoveService(index)}
                className="remove-chip-btn"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>

      <div className="form-group">
        <label htmlFor="pricing">Pricing Information</label>
        <textarea
          id="pricing"
          value={data.pricing || ''}
          onChange={(e) => onChange({ ...data, pricing: e.target.value })}
          placeholder="Describe your pricing structure, starting prices, etc."
          className="form-textarea"
          rows="3"
        />
      </div>

      <div className="form-group">
        <label>Operating Days</label>
        <div className="days-toggle-container">
          {daysOfWeek.map(day => (
            <button
              key={day}
              type="button"
              onClick={() => toggleDay(day)}
              className={`day-toggle ${(data.operatingDays || []).includes(day) ? 'active' : ''}`}
            >
              {day.substring(0, 3)}
            </button>
          ))}
        </div>
      </div>

      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="openingTime">Opening Time</label>
          <input
            type="time"
            id="openingTime"
            value={data.openingTime || ''}
            onChange={(e) => onChange({ ...data, openingTime: e.target.value })}
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="closingTime">Closing Time</label>
          <input
            type="time"
            id="closingTime"
            value={data.closingTime || ''}
            onChange={(e) => onChange({ ...data, closingTime: e.target.value })}
            className="form-input"
          />
        </div>
      </div>
    </div>
  );
};

StepServicesHours.propTypes = {
  data: PropTypes.shape({
    services: PropTypes.array,
    pricing: PropTypes.string,
    operatingDays: PropTypes.array,
    openingTime: PropTypes.string,
    closingTime: PropTypes.string
  }).isRequired,
  onChange: PropTypes.func.isRequired
};

export default StepServicesHours;
